import { Button } from "antd";
import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertRefund = (refunds, handleOpenPreview) => {
  let convertedRefunds = [];

  if (!refunds) return [];

  refunds.forEach((refund, index) => {
    convertedRefunds.push({
      key: index + 1,
      gadaiID: refund.gadai_id,
      dateTime: formatDate(refund.date_time) || "-",
      pawnNumber: refund.gadai_code || "-",
      receiptNumber: refund.receipt_number || "-",
      gadaiCode: refund.gadai_code || "-",
      customerName: refund.customer_name || "-",
      reward: `Rp ${CurrencyFormat(refund.reward) || 0}`,
      remainingMoney: `Rp ${
        CurrencyFormat(refund.remaining_auction_money) || 0
      }`,
      accountName: refund.bank_account_name || "-",
      bankOrAccountNumber:
        `${refund.bank_name || "-"} / ${refund.account_number || "-"}` || "-",
      description: refund.description || "-",
      transferProof: refund.transfer_proof ? (
        <Button
          onClick={handleOpenPreview(
            `gadai-transfer/${refund?.gadai_transfer_id}/proof-picture`
          )}
          type="link"
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
      approvalProof: refund.approval_proof ? (
        <Button
          onClick={handleOpenPreview(
            `gadai-refund/${refund?.gadai_refund_id}/approval-proof-picture`
          )}
          type="link"
        >
          Lihat File
        </Button>
      ) : (
        "-"
      ),
    });
  });
  return convertedRefunds;
};
